import { Col, Form, InputNumber, Row, Switch, Typography } from 'antd'

export type SettingsNumField = {
  name: string
  label: string
  extra: string
  min: number
  max: number
  step?: number
  disabled?: boolean
}

export type SettingsSwitchField = {
  name: string
  label: string
  extra: string
  checkedChildren?: string
  unCheckedChildren?: string
  disabled?: boolean
}

export function SettingsGroupDesc({ children }: { children: string }) {
  return (
    <Typography.Paragraph type="secondary" className="model-settings-chat-group-desc">
      {children}
    </Typography.Paragraph>
  )
}

export function SettingsNumGrid({ fields }: { fields: SettingsNumField[] }) {
  return (
    <Row gutter={[24, 0]} className="model-settings-chat-grid">
      {fields.map((f) => (
        <Col xs={24} md={12} key={f.name}>
          <Form.Item
            name={f.name}
            label={f.label}
            extra={f.extra}
            rules={[{ required: true, message: `请填写${f.label}` }]}
          >
            <InputNumber
              min={f.min}
              max={f.max}
              step={f.step}
              disabled={f.disabled}
              className="model-settings-input-full"
            />
          </Form.Item>
        </Col>
      ))}
    </Row>
  )
}

export function SettingsSwitchList({ fields }: { fields: SettingsSwitchField[] }) {
  return (
    <div className="model-settings-switch-list">
      {fields.map((f) => (
        <div key={f.name} className="model-settings-switch-row">
          <div className="model-settings-switch-text">
            <div className="model-settings-switch-label">{f.label}</div>
            <Typography.Paragraph type="secondary" className="model-settings-switch-extra">
              {f.extra}
            </Typography.Paragraph>
          </div>
          <Form.Item name={f.name} valuePropName="checked" noStyle>
            <Switch
              checkedChildren={f.checkedChildren}
              unCheckedChildren={f.unCheckedChildren}
              disabled={f.disabled}
            />
          </Form.Item>
        </div>
      ))}
    </div>
  )
}
